import { styled, Tooltip, Typography } from '@mui/material';

export const TooltipText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  fontFamily: 'Calibre-R',
  padding: '16px',
  color: '#fff',
  backgroundColor: '#282828',
});

export const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ tooltip: className }} />
))({
  backgroundColor: '#282828',
  color: '#fff',
  fontFamily: 'Calibre-R',
  padding: 0,
  margin: 0,
  marginRight: '14px',
});
